import { fetchBus } from '@/api/service'
const getBus = (context) => {
  fetchBus().then((response) => {
    context.commit('BUS_UPDATED', response)
  })
}

export default {
  getBus
}
